
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";

@Component({
	name: "Pagos",
})

export default class Pagos extends Vue {
	@Prop() paciente_id!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	pago = {
		paciente_id: null,
		consulta_id: null,
		fecha_pago: DateTime.now().toFormat('yyyy-MM-dd'),
		monto: 0,
		metodo_pago: 'EFECTIVO'
	};
	pagos = []
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	descripcion = ''
	mounted() {
		this.getPagos()
	}

	get tratamientos() {
		return this.consultorioStore.tratamientos;
	}
	get loading() {
		return this.consultorioStore.loading;
	}
	get consultas(): any {
		return this.consultorioStore.consultas;
	}

	haber(pagos: any) {
		let total = 0;
		if (pagos.length) {
			total = pagos.reduce((sum, val) => {
				return sum + parseFloat(val.monto)
			}, 0)
		}

		return total;
	}

	async getPagos() {
		await http.get(`getCitaPagos/${this.paciente_id}`).subscribe({
			next: (response: AxiosResponse) => {
				this.consultorioStore.consultas = response.data
			},
		})
	}
	registrarPago() {
		if (!this.$refs.form.validate()) {
			Alert.warning(`Lene todos los campos obligatorios (*)`)
			return;
		}
		this.pago.paciente_id = this.paciente_id;
		Alert.confirm(`Se registrará el pago de  ${this.pago.monto} Bs`, 'Registrar Pago?').then(async result => {
			if (result.isConfirmed) {
				await this.consultorioService.storePago(this.pago).then(res => {
					this.consultorioService.getHistorial(this.paciente_id)
					this.pagos = []
				})
			}
		})
	}
	seleccionarConsulta(pagos_consulta: any) {
		this.pagos = pagos_consulta
	}


}

